import styled from '@emotion/styled';

export const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    gap: 32px;
    flex-direction: row;
  }
`;

export const TitleStlyed = styled.div`
  color: ${({ theme }) => theme.colors.asphalt[1]};
`;
